import { tickerItems } from '@/mocks/home';

export default function NewsTicker() {
  const loopItems = [...tickerItems, ...tickerItems];

  return (
    <section className="border-b border-background-200/70 bg-primary-50">
      <div className="mx-auto flex w-full max-w-[1440px] items-center gap-3 px-4 py-2.5 md:px-6 lg:px-10">
        <span className="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
          <i className="ri-flashlight-line"></i>
          实时快讯
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-ticker items-center gap-10 whitespace-nowrap">
            {loopItems.map((item, index) => (
              <span
                key={`${item}-${index}`}
                className="flex items-center text-sm text-foreground-700"
              >
                <i className="ri-record-circle-line mr-2 text-xs text-primary-500"></i>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}